import { defineComponent as _defineComponent } from 'vue'
import { useEventGuestsQuery } from '@/enitites/event/api/queries'
import { useImage } from '@/shared/composables/image'
import { IEventEdit } from '@/enitites/event'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventGuestList',
  props: {
    eventData: null
  },
  setup(__props: any) {

const props = __props as {
  eventData: IEventEdit
};



const { data: guests, isLoading: isLoadingGuests } = useEventGuestsQuery(props.eventData.id)
const { getAvatar } = useImage()

return { __sfc: true,props, guests, isLoadingGuests, getAvatar }
}

})